import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import 'antd/dist/antd.variable.min.css';
import '@/styles/style.scss';
import App from './app';
import { initErrorHandler } from '@/utils';

export type RunOptions = {
  el?: HTMLElement;
};

// 客户端渲染
export const run = async (options: RunOptions = {}) => {
  // 初始化全局错误监听
  // initErrorHandler();

  const el = options.el || document.getElementById('root')!;
  const root = createRoot(el);
  root.render(
    React.createElement(App)
    // React.createElement(
    //   SWRConfig,
    //   {
    //     value: {
    //       revalidateOnFocus: false,
    //       revalidateOnReconnect: false,
    //       shouldRetryOnError: false,
    //       revalidateIfStale: false,
    //     },
    //   },
    //   React.createElement(App)
    // )
  );
};

// ssr 水合
// export const run = async (options: RunOptions = {}) => {
//   const el = options.el || document.getElementById('root')!;
//   hydrateRoot(el, React.createElement(App));
// };
